import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María José',
  city: 'Buenos Aires'
}, {
  name: 'Camila R.',
  city: 'Córdoba'
}, {
  name: 'Sofía G.',
  city: 'Rosario'
}, {
  name: 'Valentina M.',
  city: 'Mendoza'
}, {
  name: 'Florencia P.',
  city: 'La Plata'
}, {
  name: 'Martina L.',
  city: 'Mar del Plata'
}, {
  name: 'Lucía A.',
  city: 'Tucumán'
}, {
  name: 'Agustina D.',
  city: 'Salta'
}, {
  name: 'Belén S.',
  city: 'Neuquén'
}, {
  name: 'Rocío C.',
  city: 'Santa Fe'
}, {
  name: 'Julieta V.',
  city: 'Bahía Blanca'
}, {
  name: 'Antonella F.',
  city: 'San Juan'
}, {
  name: 'Carolina B.',
  city: 'Paraná'
}, {
  name: 'Micaela T.',
  city: 'Posadas'
}, {
  name: 'Ailén M.',
  city: 'Resistencia'
}];
function randomMinutes() {
  return Math.floor(Math.random() * 14) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [minutes, setMinutes] = useState(randomMinutes());
  useEffect(() => {
    // First appearance after a short delay
    const firstTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(firstTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Show for 4 seconds, then hide for 1 second before next pops up — total ~5s cycle
    const hideTimer = setTimeout(() => {
      setVisible(false);
      const nextTimer = setTimeout(() => {
        setIndex(i => (i + 1) % PURCHASES.length);
        setMinutes(randomMinutes());
        setVisible(true);
      }, 1000);
      return () => clearTimeout(nextTimer);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, index]);
  const purchase = PURCHASES[index];
  return <div className={`fixed bottom-4 left-4 z-[60] max-w-[280px] sm:max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-169">
      <div className="bg-white border border-[#f4b6c2]/40 rounded-2xl p-3 shadow-[0_8px_30px_rgba(232,154,170,0.18)] backdrop-blur-sm flex items-start gap-3" data-id="element-170">
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#fdf2f4] to-[#fce7e9] flex items-center justify-center flex-shrink-0 text-[#e89aaa]" data-id="element-171">
          ♡
        </div>
        <div className="min-w-0 flex-1" data-id="element-172">
          <p className="text-[#6b4f3a] text-xs font-semibold leading-tight" data-id="element-173">
            <span className="text-[#e89aaa]" data-id="element-174">{purchase.name}</span>
            <span className="text-[#8b6f47] font-normal" data-id="element-175"> de </span>
            <span data-id="element-176">{purchase.city}</span>
          </p>
          <p className="text-[#8b6f47] text-[11px] mt-0.5 leading-tight" data-id="element-177">
            acaba de adquirir el{' '}
            <span className="font-medium text-[#6b4f3a]" data-id="element-178">
              MegaPack Pastelería
            </span>
          </p>
          <p className="text-[#8b6f47]/60 text-[10px] mt-1 flex items-center gap-1" data-id="element-179">
            <span className="w-1.5 h-1.5 rounded-full bg-[#e89aaa] animate-pulse" data-id="element-180"></span>
            hace {minutes} minutos
          </p>
        </div>
      </div>
    </div>;
}